import SyncAltIcon from "@mui/icons-material/SyncAlt";

const icons = {
  SyncAltIcon
};

const planmapping = {
  id: 'assignrole',
  type: 'group',
  children: [
    {
      id: 'planmapping',
      title: 'Plan Mapping',
      type: 'item',
      url: '/plan-mapping',
      icon: icons.SyncAltIcon,
    }
  ]
};

export default planmapping;
